import { render, staticRenderFns } from "./zxks.vue?vue&type=template&id=d960d6da&scoped=true&"
import script from "./zxks.vue?vue&type=script&lang=js&"
export * from "./zxks.vue?vue&type=script&lang=js&"
import style0 from "./zxks.vue?vue&type=style&index=0&id=d960d6da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d960d6da",
  null
  
)

export default component.exports